<template>
  <v-card :tag="tag" class="notice-module" :level="1" :heading="title">
    <p v-if="description">{{description}}</p>
    <a v-for="(file, index) in files" :key="index" :href="file.url" download>
      <span>{{file.title}}</span>
      <i class="icon-download"></i>
    </a>
  </v-card>
</template>

<script>
import Card from '@/components/layout/Card.vue';

export default {
  name: 'NoticeModule',
  components: {
    'v-card': Card,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    tag: {
      type: String,
      default: 'div',
    },
    files: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
$component: '.notice-module';
#{$component} {
  padding: 0;
  border: 1px solid $color-sys-h;
  /deep/ .card__title {
    background-color: $color-d;
  }
  p {
    margin: 0;
    padding: $gutter-l;
    border-bottom: 1px solid $color-sys-h;
    font-size: $font-size-l;
  }
  a {
    padding: $gutter $gutter-l;
    margin: $gutter 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: $font-size-l;
    font-weight: $font-weight-heavy;
    text-decoration: none;
    color: $color-sys-f;
    transition: color $transition-duration $transition-timing-function;
    span {
      padding-right: $gutter-l;
      color: inherit;
    }
    i {
      color: inherit;
    }
    &:hover {
      color: $color-sys-b;
    }
  }
}
</style>
